import { useAccessControlForm } from "@/features/management-settings/hooks/use-access-control-form";
import type { SubjectDto, SubjectDtoType } from "@/spz-api/model";

interface SelectAccessControlFormViewModelProps {
  subjectId: SubjectDto["id"];
  subjectType: SubjectDtoType;
}

export const selectAccessControlFormViewModel = ({
  subjectId,
  subjectType,
}: SelectAccessControlFormViewModelProps) => {
  const accessControlForm = useAccessControlForm({
    subjectId,
    subjectType,
  });

  return {
    form: accessControlForm.form,
    onSubmit: accessControlForm.onSubmit,
    roles: accessControlForm.roles,
    companies: accessControlForm.companies,
    isLoading: accessControlForm.isLoading,
  };
};
